import Switch from "@mui/material/Switch";

const columns = (onEdit, toggleStatus) => [
	{
		headerName: "Category Image",
		field: "media",
		renderCell: ({ row }) => (
			<div>
				<img src={row.media} alt="" style={{ height: "50px", width: "50px" }} />
			</div>
		),
	},
	{
		headerName: "Master Categories",
		field: "Category",
	},
	{ headerName: "Sub Categories", field: "subCategories" },
	{ headerName: "Status", field: "status", 
		renderCell: ({ row }) => (
			<Switch
			checked={row.status === "ACTIVE"}
			color="primary"
			onChange={val => toggleStatus(row)}
			/>
		)
	},
	{
		headerName: "Action",
		field: "action",
		renderCell: ({row}) => (
			<div>
				<span className="text-theme cursor-pointer" onClick={() => onEdit(row)}>Edit</span>
			</div>
		),
	},
];

const rows: any = (data = []) =>
	data.map((item: any) => ({
		...item,
		id: item.id,
		Category: item.name || "",
		// subCategories: "Shirt",
	}));

const onClick: any = (params: any) => {};
const dataTableData = (data: any, onEdit = (e) => {}, toggleStatus = (e) => {}) => ({
	columns: columns(onEdit, toggleStatus),
	rows: rows(data),
	onClick,
});

export default dataTableData;
